module.exports = __webpack_public_path__ + "img/cfa09b7.png";